import React, { useState, useEffect, useMemo, useRef } from 'react';
import { X, ClipboardCheck, Plus, Filter, HelpCircle } from 'lucide-react';
import { useNavigate, useLocation, useSearchParams, useParams } from 'react-router-dom';
import CreatableSelect from 'react-select/creatable';
import { Slider } from 'antd';
import axiosInstance from '../utils/axiosInterceptor';
import toast from 'react-hot-toast';
import AssessmentsList from '../components/dashboard/AssessmentsList';
import AllCandidatesList from '../components/dashboard/AllCandidatesList';
import AssessmentDetail from '../components/dashboard/AssessmentDetail';
import { useAuth } from '../contexts/AuthContext';

// Mock user data

// Mock job roles
const jobRoles = [
  { value: 'frontend-developer', label: 'Frontend Developer' },
  { value: 'backend-developer', label: 'Backend Developer' },
  { value: 'full-stack-developer', label: 'Full Stack Developer' },
  { value: 'devops-engineer', label: 'DevOps Engineer' },
  { value: 'data-scientist', label: 'Data Scientist' },
  { value: 'ui-ux-designer', label: 'UI/UX Designer' },
  { value: 'product-manager', label: 'Product Manager' },
  { value: 'qa-engineer', label: 'QA Engineer' },
  { value: 'mobile-developer', label: 'Mobile Developer' },
  { value: 'security-engineer', label: 'Security Engineer' },
  { value: 'cloud-architect', label: 'Cloud Architect' },
  { value: 'machine-learning-engineer', label: 'Machine Learning Engineer' },
  { value: 'software-engineer', label: 'Software Engineer' },
  { value: 'technical-lead', label: 'Technical Lead' },
  { value: 'engineering-manager', label: 'Engineering Manager' },
];



const Dashboard: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const params = useParams();
  const { user } = useAuth();
  
  // Form state
  const [selectedRole, setSelectedRole] = useState<any>(null);
  const [workExpMin, setWorkExpMin] = useState(0);
  const [workExpMax, setWorkExpMax] = useState(15);
  const [interviewDuration, setInterviewDuration] = useState(15);
  const [jobDescription, setJobDescription] = useState('');
  const [assessments, setAssessments] = useState<any>([]);
  const [userName, setUserName] = useState('');
  const [assessmentsPage, setAssessmentsPage] = useState(1);
  const [assessmentsHasMore, setAssessmentsHasMore] = useState(true);
  const [assessmentsTotal, setAssessmentsTotal] = useState(0);
  const [assessmentsTotalPages, setAssessmentsTotalPages] = useState(1);
  
  useEffect(() => {
    const user = localStorage.getItem('interview_login_user');
    const userData = JSON.parse(user || '{}');
    console.log(userData,"userData")
    if(user){
      setUserName(userData.email.split('@')[0]);
    }
  }, [user]);
  // Validation state
  const [errors, setErrors] = useState<{
    role: string;
    workExp: string;
    duration: string;
    jd: string;
  }>({
    role: '',
    workExp: '',
    duration: '',
    jd: '',
  });
  
  // Filter state
  const [statusFilter, setStatusFilter] = useState<'all' | 'active' | 'inactive' | 'draft'>('all');
  
  // Search state
  const [assessmentSearch, setAssessmentSearch] = useState('');
  const [debouncedAssessmentSearch, setDebouncedAssessmentSearch] = useState('');
  
  // Selected assessment state
  const [selectedAssessment, setSelectedAssessment] = useState<any>(null);
  
  // Candidate invitation state
  const [candidateRows, setCandidateRows] = useState([
    { firstName: '', lastName: '', email: '', phone: '' },
   
  ]);
  
  // Candidate validation errors state
  const [candidateErrors, setCandidateErrors] = useState<Array<{
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string;
  }>>([{}]);
  
  // Existing candidates state
  const [existingCandidates, setExistingCandidates] = useState<any[]>([]);
  const [isCandidatesExpanded, setIsCandidatesExpanded] = useState(false);
  const [existingCandidatesLoading, setExistingCandidatesLoading] = useState(false);
  const [existingCandidatesPage, setExistingCandidatesPage] = useState(1);
  const [existingCandidatesTotal, setExistingCandidatesTotal] = useState(0);
  const existingCandidatesItemsPerPage = 10;
  
  // Sidebar navigation state
  const [activeSidebarItem, setActiveSidebarItem] = useState<'skills' | 'candidates' | 'settings'>('candidates');
  const sidebarItemSetByNavigation = useRef<boolean>(false);
  
  // Active menu item state - determine from URL path
  const getActiveMenuItem = () => {
    if (location.pathname.startsWith('/dashboard/assessment/')) {
      return 'assessment';
    }
    if (location.pathname.startsWith('/dashboard/candidates')) {
      return 'candidates';
    }
    return 'assessment'; // default
  };
  
  const activeMenuItem = getActiveMenuItem();

  // Clear selected assessment when navigating away from assessment detail
  useEffect(() => {
    // Clear selected assessment if we're not on an assessment detail page
    if (!location.pathname.startsWith('/dashboard/assessment/') && selectedAssessment) {
      setSelectedAssessment(null);
    }
    // Also clear if we're on the base dashboard route
    if (location.pathname === '/dashboard' && selectedAssessment) {
      setSelectedAssessment(null);
    }
  }, [location.pathname, selectedAssessment]);
  
  // All candidates state (for Candidates tab)
  const [allCandidates, setAllCandidates] = useState<any[]>([]);
  const [candidatesLoading, setCandidatesLoading] = useState(false);
  const [candidatesPage, setCandidatesPage] = useState(1);
  const [candidatesHasMore, setCandidatesHasMore] = useState(true);
  const [candidatesTotal, setCandidatesTotal] = useState(0);
  const [candidatesTotalPages, setCandidatesTotalPages] = useState(1);
  
  // Candidates filters state
  const [candidateSearch, setCandidateSearch] = useState('');
  const [candidateStatusFilter, setCandidateStatusFilter] = useState<string>('all');
  const [candidateDateFilter, setCandidateDateFilter] = useState<{ start: string; end: string }>({ start: '', end: '' });
  
  // Skills state
  const [skills, setSkills] = useState<Array<{ _id: string; name: string; timeLimit: number; difficulty: string; hasQuestions: boolean; questions?: Array<{ id: string; text: string }> }>>([
   
  ]);
  
  // Edit skill modal state
  const [isEditSkillModalOpen, setIsEditSkillModalOpen] = useState(false);
  const [editingSkill, setEditingSkill] = useState<{ _id: string; name: string; timeLimit: number; difficulty: string; hasQuestions: boolean; questions?: Array<{ id: string; text: string }> } | null>(null);
  const [editSkillForm, setEditSkillForm] = useState({ name: '', timeLimit: 0, difficulty: 'Beginner', hasQuestions: false, questions: [] as Array<{ id: string; text: string }> });
  const [newQuestionText, setNewQuestionText] = useState('');
  
  // Add skill modal state
  const [isAddSkillModalOpen, setIsAddSkillModalOpen] = useState(false);
  const [addSkillForm, setAddSkillForm] = useState({ name: '', timeLimit: 0, difficulty: 'Beginner', hasQuestions: false, questions: [] as Array<{ id: string; text: string }> });
  const [newAddQuestionText, setNewAddQuestionText] = useState('');
  
  // Delete skill confirmation modal state
  const [isDeleteSkillModalOpen, setIsDeleteSkillModalOpen] = useState(false);
  const [skillToDelete, setSkillToDelete] = useState<{ _id: string; name: string } | null>(null);
  
  // Use mock data
  // const assessments = mockAssessments;
  
  // Assessments are already filtered by API, so use them directly
  const filteredAssessments = assessments;

  // Debounced search for candidates
  const [debouncedSearch, setDebouncedSearch] = useState('');
  
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(candidateSearch);
    }, 500);
    return () => clearTimeout(timer);
  }, [candidateSearch]);

  // Debounced search for assessments
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedAssessmentSearch(assessmentSearch);
    }, 500);
    return () => clearTimeout(timer);
  }, [assessmentSearch]);


  const [assessmentsLoading, setAssessmentsLoading] = useState(true);

  // Fetch assessments from API with status filter, search, and pagination
  const fetchAssessments = React.useCallback(async (page: number = 1, reset: boolean = false) => {
    setAssessmentsLoading(true);
    try {
      const params: any = {
        page: page,
        limit: 20
      };
      if (statusFilter !== 'all') {
        params.status = statusFilter;
      }
      if (debouncedAssessmentSearch && debouncedAssessmentSearch.trim()) {
        params.search = debouncedAssessmentSearch.trim();
      }
      
      const response = await axiosInstance.get('/assessments/all', { params });
      console.log(response.data, "response");
      
      if (response.data.data && Array.isArray(response.data.data)) {
        setAssessments(response.data.data);
        setAssessmentsHasMore(response.data.pagination?.hasMore || false);
        setAssessmentsTotal(response.data.pagination?.total || 0);
        setAssessmentsTotalPages(response.data.pagination?.totalPages || 1);
      }
    } catch (error: any) {
      console.log(error, "error");
      toast.error('Failed to fetch assessments');
      if (reset) {
        setAssessments([]);
      }
    } finally {
      setAssessmentsLoading(false);
    }
  }, [statusFilter, debouncedAssessmentSearch]);

  // Initial fetch and when filters or search change
  useEffect(() => {
    setAssessmentsPage(1);
    setAssessments([]);
    setAssessmentsHasMore(true);
    fetchAssessments(1, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusFilter, debouncedAssessmentSearch]);

  // Handle page change for assessments
  const handleAssessmentsPageChange = (page: number) => {
    setAssessmentsPage(page);
    fetchAssessments(page, true);
    // Scroll to top when page changes
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Call API when skills section is active
  useEffect(() => {
    if (activeSidebarItem === 'skills' && selectedAssessment) {
      // Call API to fetch skills for the selected assessment
      axiosInstance.get(`/assessments/${selectedAssessment._id}/skills`)
        .then((response: any) => {
          console.log(response.data.data.skills, "skills response");

          // Update skills state with fetched data
          if (response.data.data && Array.isArray(response.data.data.skills)) {
            console.log(response.data.data.skills,"skills")
            // Map skills to ensure timeLimit field exists (handle both 'time' and 'timeLimit' from API)
            const mappedSkills = response.data.data.skills.map((skill: any) => ({
              ...skill,
              timeLimit: skill.timeLimit || skill.time || 15,
            }));
            setSkills(mappedSkills);
          }
        })
        .catch((error: any) => {
          console.log(error, "error fetching skills");
        });
    }
  }, [activeSidebarItem, selectedAssessment]);

  // Call API when candidates section is active (for specific assessment)
  const fetchExistingCandidates = React.useCallback(async (page: number = 1) => {
    if (!selectedAssessment) return;
    
    setExistingCandidatesLoading(true);
    try {
      // Call API to fetch existing candidates with pagination
      const response = await axiosInstance.get(`/candidates/${selectedAssessment._id}/candidates`, {
        params: {
          page: page,
          limit: existingCandidatesItemsPerPage
        }
      });
      
      console.log("Full API response:", response.data);
      console.log("Pagination object:", response.data.pagination);
      
      // Update existing candidates state with fetched data
      // Backend returns: { success: true, data: [...], pagination: { total, page, limit, ... } }
      if (response.data && response.data.success) {
        const candidates = Array.isArray(response.data.data) ? response.data.data : [];
        const total = response.data.pagination?.total ?? 0;
        
        setExistingCandidates(candidates);
        setExistingCandidatesTotal(total);
        
        console.log(`Fetched ${candidates.length} candidates, total: ${total}, page: ${response.data.pagination?.page}, limit: ${response.data.pagination?.limit}`);
      } else {
        // Set empty array if API returns unexpected structure
        console.warn("Unexpected API response structure:", response.data);
        setExistingCandidates([]);
        setExistingCandidatesTotal(0);
      }
    } catch (error: any) {
      console.log(error, "error fetching candidates");
      // Set empty array on error
      setExistingCandidates([]);
      setExistingCandidatesTotal(0);
    } finally {
      setExistingCandidatesLoading(false);
    }
  }, [selectedAssessment, existingCandidatesItemsPerPage]);

  useEffect(() => {
    if (activeSidebarItem === 'candidates' && selectedAssessment) {
      fetchExistingCandidates(existingCandidatesPage);
    } else {
      setExistingCandidatesLoading(false);
    }
  }, [activeSidebarItem, selectedAssessment, existingCandidatesPage, fetchExistingCandidates]);

  // Handle page change for existing candidates
  const handleExistingCandidatesPageChange = (page: number) => {
    setExistingCandidatesPage(page);
  };

  // Fetch all candidates when Candidates tab is active or filters change
  const fetchCandidates = React.useCallback(async (page: number = 1, reset: boolean = false) => {
    if (activeMenuItem !== 'candidates') return;
    
    setCandidatesLoading(true);
    try {
      const params = new URLSearchParams();
      if (debouncedSearch) params.append('search', debouncedSearch);
      if (candidateStatusFilter !== 'all') params.append('status', candidateStatusFilter);
      if (candidateDateFilter.start) params.append('startDate', candidateDateFilter.start);
      if (candidateDateFilter.end) params.append('endDate', candidateDateFilter.end);
      params.append('page', page.toString());
      params.append('limit', '20');

      const response = await axiosInstance.get(`/candidates/all?${params.toString()}`);
      console.log(response.data, "all candidates response");
      
      if (response.data.data && Array.isArray(response.data.data)) {
        setAllCandidates(response.data.data);
        setCandidatesHasMore(response.data.pagination?.hasMore || false);
        setCandidatesTotal(response.data.pagination?.total || 0);
        setCandidatesTotalPages(response.data.pagination?.totalPages || response.data.pagination?.pages || 1);
      }
    } catch (error: any) {
      console.log(error, "error fetching all candidates");
      if (reset) {
        setAllCandidates([]);
      }
    } finally {
      setCandidatesLoading(false);
    }
  }, [activeMenuItem, debouncedSearch, candidateStatusFilter, candidateDateFilter.start, candidateDateFilter.end]);

  // Initial fetch and when filters change
  useEffect(() => {
    if (activeMenuItem === 'candidates') {
      setCandidatesPage(1);
      setAllCandidates([]);
      setCandidatesHasMore(true);
      fetchCandidates(1, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeMenuItem, debouncedSearch, candidateStatusFilter, candidateDateFilter.start, candidateDateFilter.end]);

  // Handle page change for candidates
  const handleCandidatesPageChange = (page: number) => {
    setCandidatesPage(page);
    fetchCandidates(page, true);
    // Scroll to top when page changes
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };


  const handleSendInvitations = () => {
    try {
      // Filter out completely empty rows
      const validRows = candidateRows.filter(row => 
        row.firstName.trim() || row.lastName.trim() || row.email.trim() || row.phone.trim()
      );
      
      if(validRows.length === 0){
        toast.error("Please add at least one candidate");
        return;
      }
      
      // Validate all rows
      const errors: Array<{ firstName?: string; lastName?: string; email?: string; phone?: string }> = [];
      let hasErrors = false;

      validRows.forEach((row, index) => {
        const rowErrors = validateCandidateRow(row, index);
        errors[index] = rowErrors;
        if (Object.keys(rowErrors).length > 0) {
          hasErrors = true;
        }
      });

      setCandidateErrors(errors);

      if (hasErrors) {
        toast.error("Please fix all validation errors before submitting");
        return;
      }
      
      axiosInstance.post(`/candidates/${selectedAssessment._id}/candidates`, validRows).then((response:any)=>{
        console.log(response.data,"response")
        toast.success(response.data.message || "Invitations sent successfully")
        // Clear the form rows and errors
        setCandidateRows([{ firstName: '', lastName: '', email: '', phone: '' }]);
        setCandidateErrors([{}]);
        // Refresh existing candidates list - reset to page 1 to see newly added candidates
        if (selectedAssessment) {
          setExistingCandidatesPage(1);
          fetchExistingCandidates(1);
        }
      }).catch((error:any)=>{
        console.log(error,"error")
        const errorMessage = error.response?.data?.error || error.response?.data?.message || "Failed to send invitations";
        toast.error(errorMessage);
      })
    } catch (error) {
      console.log(error,"error")
      toast.error("An error occurred")
    }
  }

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    // Reset form
    setSelectedRole(null);
    setWorkExpMin(0);
    setWorkExpMax(15);
    setInterviewDuration(15);
    setJobDescription('');
    setErrors({ role: '', workExp: '', duration: '', jd: '' });
  };

  const validateForm = () => {
    const newErrors = { role: '', workExp: '', duration: '', jd: '' };
    let isValid = true;

    if (!selectedRole) {
      newErrors.role = 'Role is required';
      isValid = false;
    }

    if (workExpMin > workExpMax) {
      newErrors.workExp = 'Minimum experience cannot be greater than maximum';
      isValid = false;
    }

    if (!interviewDuration || interviewDuration < 5 || interviewDuration > 40) {
      newErrors.duration = 'Interview duration must be between 5 and 40 minutes';
      isValid = false;
    }

    if (!jobDescription.trim()) {
      newErrors.jd = 'Job Description is required';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validateForm()) {
      // Create new assessment object
      const newAssessment = {
        _id: Date.now().toString(),
        title: `EarlyJobs ${selectedRole?.label || 'Assessment'}`,
        description: jobDescription,
        role: selectedRole?.label || '',
        workExpMin,
        workExpMax,
        duration: interviewDuration,
        skillsCount: 0,
      };
      axiosInstance.post('/assessments/create', newAssessment).then((response:any)=>{
           // Close modal after successful submission
      closeModal();
      navigate(`/dashboard/assessment/${response.data.data._id}`);
      // Set the selected assessment to show candidate invitation view
      setSelectedAssessment(response.data.data);
      
      }).catch((error:any)=>{
        console.log(error.response.data.errorCode,"==error")
        const errorCode = error?.response?.data?.errorCode;
        if(errorCode === 10013){
          setErrors({ ...errors, jd: 'Job Description is not valid for the role' });
          return;
        }
      })
      
      
   
    }
  };

  const handleBackToAssessments = () => {
    setSelectedAssessment(null);
    setActiveSidebarItem('skills');
    // Navigate to dashboard to update URL
    navigate('/dashboard', { replace: true });
  };

  const handleAddCandidateRow = () => {
    // Add one row at a time, maximum 4 rows total
    if (candidateRows.length < 4) {
    setCandidateRows([...candidateRows, { firstName: '', lastName: '', email: '', phone: '' }]);
      setCandidateErrors([...candidateErrors, {}]);
    } else {
      toast.error("Maximum 4 candidate rows allowed");
    }
  };

  // Email validation regex
  const validateEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Phone validation (basic - allows numbers, spaces, dashes, parentheses)
  const validatePhone = (phone: string): boolean => {
    const phoneRegex = /^[\d\s\-\(\)]+$/;
    return phoneRegex.test(phone) && phone.replace(/\D/g, '').length >= 10;
  };

  const validateCandidateRow = (row: { firstName: string; lastName: string; email: string; phone: string }, index: number): { firstName?: string; lastName?: string; email?: string; phone?: string } => {
    const errors: { firstName?: string; lastName?: string; email?: string; phone?: string } = {};

    if (!row.firstName.trim()) {
      errors.firstName = 'First name is required';
    }

    if (!row.lastName.trim()) {
      errors.lastName = 'Last name is required';
    }

    if (!row.email.trim()) {
      errors.email = 'Email is required';
    } else if (!validateEmail(row.email.trim())) {
      errors.email = 'Please enter a valid email address';
    }

    if (!row.phone.trim()) {
      errors.phone = 'Phone number is required';
    } else if (!validatePhone(row.phone.trim())) {
      errors.phone = 'Please enter a valid phone number (minimum 10 digits)';
    }

    return errors;
  };

  const handleCandidateInputChange = (index: number, field: string, value: string) => {
    const newRows = [...candidateRows];
    newRows[index] = { ...newRows[index], [field]: value };
    setCandidateRows(newRows);

    // Clear error for this field when user starts typing
    const newErrors = [...candidateErrors];
    if (newErrors[index]) {
      newErrors[index] = { ...newErrors[index], [field]: undefined };
    }
    setCandidateErrors(newErrors);
  };

  const handleWorkExpMinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(e.target.value);
    if (value <= workExpMax) {
      setWorkExpMin(value);
      if (errors.workExp) {
        setErrors({ ...errors, workExp: '' });
      }
    }
  };

  const handleWorkExpMaxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(e.target.value);
    if (value >= workExpMin) {
      setWorkExpMax(value);
      if (errors.workExp) {
        setErrors({ ...errors, workExp: '' });
      }
    }
  };

  const openEditSkillModal = (skill: { _id: string; name: string; timeLimit?: number; time?: number; difficulty: string; hasQuestions: boolean; questions?: Array<{ id: string; text: string }> }) => {
    const timeLimitValue = skill.timeLimit || skill.time || 15;
    setEditingSkill({
      _id: skill._id,
      name: skill.name,
      timeLimit: timeLimitValue,
      difficulty: skill.difficulty,
      hasQuestions: skill.hasQuestions || false,
      questions: skill.questions || [],
    });
    setEditSkillForm({
      name: skill.name,
      timeLimit: timeLimitValue,
      difficulty: skill.difficulty,
      hasQuestions: skill.hasQuestions || false,
      questions: skill.questions || [],
    });
    setNewQuestionText('');
    setIsEditSkillModalOpen(true);
  };

  const closeEditSkillModal = () => {
    setIsEditSkillModalOpen(false);
    setEditingSkill(null);
    setEditSkillForm({ name: '', timeLimit: 15, difficulty: 'Beginner', hasQuestions: false, questions: [] });
    setNewQuestionText('');
  };

  const handleSaveSkill = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmedName = editSkillForm.name.trim();
    if (editingSkill && trimmedName && trimmedName.length >= 2 && trimmedName.length <= 10) {
      setSkills(skills.map(skill => 
        skill._id === editingSkill._id 
          ? { ...skill, ...editSkillForm }
          : skill
      ));
      axiosInstance.put(`/assessments/${selectedAssessment._id}/skills/${editingSkill._id}`, editSkillForm)
        .then((response: any) => {
          console.log(response.data, "update skill response");
        })
        .catch((error: any) => {
          console.log(error, "error updating skill");
        });
      closeEditSkillModal();
    }
  };

  const handleAddQuestion = () => {
    if (newQuestionText.trim()) {
      const newQuestion = {
        id: Date.now().toString(),
        text: newQuestionText.trim(),
      };
      setEditSkillForm({
        ...editSkillForm,
        questions: [...editSkillForm.questions, newQuestion],
      });
      setNewQuestionText('');
    }
  };

  const handleDeleteQuestion = (questionId: string) => {
    setEditSkillForm({
      ...editSkillForm,
      questions: editSkillForm.questions.filter(q => q.id !== questionId),
    });
  };

  const handleUpdateQuestion = (questionId: string, newText: string) => {
    setEditSkillForm({
      ...editSkillForm,
      questions: editSkillForm.questions.map(q =>
        q.id === questionId ? { ...q, text: newText } : q
      ),
    });
  };

  const openDeleteSkillModal = (skillId: string) => {

    const skill = skills.find(s => s._id === skillId);
    console.log(skill,"skill to delete")
    if (skill) {
      setSkillToDelete({ _id: skill._id, name: skill.name });
      setIsDeleteSkillModalOpen(true);
    }
  };

  const closeDeleteSkillModal = () => {
    setIsDeleteSkillModalOpen(false);
    setSkillToDelete(null);
  };

  const handleDeleteSkill = () => {
    console.log(skillToDelete, selectedAssessment,"skillToDelete and selectedAssessment")
    if (skillToDelete && selectedAssessment) {
      // Call API to delete skill
      axiosInstance.delete(`/assessments/${selectedAssessment._id}/skills/${skillToDelete._id}`)
        .then((response: any) => {
          console.log(response.data, "delete skill response");
          // Remove skill from local state
          setSkills(skills.filter(skill => skill._id !== skillToDelete._id));
          closeDeleteSkillModal();
        })
        .catch((error: any) => {
          console.log(error, "error deleting skill");
          closeDeleteSkillModal();
        });
    }
  };

  const openAddSkillModal = () => {
    setIsAddSkillModalOpen(true);
    setAddSkillForm({ name: '', timeLimit: 15, difficulty: 'Beginner', hasQuestions: false, questions: [] });
    setNewAddQuestionText('');
  };

  const closeAddSkillModal = () => {
    setIsAddSkillModalOpen(false);
    setAddSkillForm({ name: '', timeLimit: 15, difficulty: 'Beginner', hasQuestions: false, questions: [] });
    setNewAddQuestionText('');
  };

  const handleAddNewSkill = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmedName = addSkillForm.name.trim();
    if (trimmedName && trimmedName.length >= 2 && trimmedName.length <= 10 && selectedAssessment) {
      const newSkill = {
        name: addSkillForm.name,
        timeLimit: addSkillForm.timeLimit,
        difficulty: addSkillForm.difficulty,
        hasQuestions: addSkillForm.hasQuestions,
        questions: addSkillForm.questions,
      };

      // Call API to add skill
      axiosInstance.post(`/assessments/${selectedAssessment._id}/skills`, newSkill)
        .then((response: any) => {
          // Refresh skills list
          if (response.data.data && response.data.data) {
            console.log(response.data.data,"response.data.data")
            setSkills([ ...response.data.data]);
          }
          closeAddSkillModal();
        })
        .catch((error: any) => {
          console.log(error, "error adding skill");
        });
    }
  };

  const handleAddNewQuestion = () => {
    if (newAddQuestionText.trim()) {
      const newQuestion = {
        id: Date.now().toString(),
        text: newAddQuestionText.trim(),
      };
      setAddSkillForm({
        ...addSkillForm,
        questions: [...addSkillForm.questions, newQuestion],
      });
      setNewAddQuestionText('');
    }
  };

  const handleDeleteNewQuestion = (questionId: string) => {
    setAddSkillForm({
      ...addSkillForm,
      questions: addSkillForm.questions.filter(q => q.id !== questionId),
    });
  };

  const handleUpdateNewQuestion = (questionId: string, newText: string) => {
    setAddSkillForm({
      ...addSkillForm,
      questions: addSkillForm.questions.map(q =>
        q.id === questionId ? { ...q, text: newText } : q
      ),
    });
  };

  const handleClickAssessment = (assessment: any) => {

    navigate(`/dashboard/assessment/${assessment._id}`);

    console.log(assessment,"assessment clicked")
    switch (assessment.status) {
      case "draft":
        // Set the selected assessment and open skills section
        setSelectedAssessment(assessment);
        setActiveSidebarItem('skills');
        break;
    
      default:
        // For other statuses, just set the selected assessment
        setSelectedAssessment(assessment);
        setActiveSidebarItem('skills');
        break;
    }
  };

  const handleNavigateToAssessment = (assessmentId: string, sidebarItem: 'skills' | 'candidates') => {
    const assessment = assessments.find((a: any) => a._id === assessmentId);
    if (assessment) {
      sidebarItemSetByNavigation.current = true;
      navigate(`/dashboard/assessment/${assessmentId}`);
      setSelectedAssessment(assessment);
      setActiveSidebarItem(sidebarItem);
      // Reset the flag after a short delay to allow useEffect to complete
      setTimeout(() => {
        sidebarItemSetByNavigation.current = false;
      }, 100);
    }
  };

  // Restore selected assessment from URL on mount/refresh
  useEffect(() => {
    // Don't override if sidebar item was just set by navigation
    if (sidebarItemSetByNavigation.current) {
      return;
    }
    
    const assessmentIdFromParams = params.id;
    
    if (assessmentIdFromParams && assessments.length > 0) {
      const assessment = assessments.find((a: any) => a._id === assessmentIdFromParams);
      if (assessment) {
        setSelectedAssessment(assessment);
        // Set appropriate sidebar item based on status only if not set by navigation
        if (assessment.status === 'draft') {
          setActiveSidebarItem('skills');
        } else {
          setActiveSidebarItem('candidates');
        }
      }
    }
  }, [params.id, assessments]);

  return (
    <>
      {activeMenuItem === 'candidates' && !selectedAssessment ? (
        <AllCandidatesList
          allCandidates={allCandidates}
          candidatesLoading={candidatesLoading}
          candidatesTotal={candidatesTotal}
          candidateSearch={candidateSearch}
          setCandidateSearch={setCandidateSearch}
          candidateStatusFilter={candidateStatusFilter}
          setCandidateStatusFilter={setCandidateStatusFilter}
          candidateDateFilter={candidateDateFilter}
          setCandidateDateFilter={setCandidateDateFilter}
          currentPage={candidatesPage}
          totalPages={candidatesTotalPages}
          onPageChange={handleCandidatesPageChange}
        />
      ) : selectedAssessment ? (
        <AssessmentDetail
          selectedAssessment={selectedAssessment}
          handleBackToAssessments={handleBackToAssessments}
          activeSidebarItem={activeSidebarItem}
          setActiveSidebarItem={setActiveSidebarItem}
          skills={skills}
          openEditSkillModal={openEditSkillModal}
          openDeleteSkillModal={openDeleteSkillModal}
          openAddSkillModal={openAddSkillModal}
          existingCandidates={existingCandidates}
          isCandidatesExpanded={isCandidatesExpanded}
          setIsCandidatesExpanded={setIsCandidatesExpanded}
          candidateRows={candidateRows}
          candidateErrors={candidateErrors}
          handleCandidateInputChange={handleCandidateInputChange}
          handleAddCandidateRow={handleAddCandidateRow}
          handleSendInvitations={handleSendInvitations}
          candidatesLoading={existingCandidatesLoading}
          candidatesPage={existingCandidatesPage}
          candidatesTotal={existingCandidatesTotal}
          candidatesItemsPerPage={existingCandidatesItemsPerPage}
          onPageChange={handleExistingCandidatesPageChange}
        />
      ) : (
        <AssessmentsList
          assessments={assessments}
          filteredAssessments={filteredAssessments}
          statusFilter={statusFilter}
          setStatusFilter={setStatusFilter}
          openModal={openModal}
          handleClickAssessment={handleClickAssessment}
          mockUserName={userName}
          onAssessmentDeleted={() => {
            // Refresh assessments list after deletion with current filter - reset to page 1
            setAssessmentsPage(1);
            setAssessments([]);
            setAssessmentsHasMore(true);
            fetchAssessments(1, true);
          }}
          onNavigateToAssessment={handleNavigateToAssessment}
          isLoading={assessmentsLoading}
          hasMore={assessmentsHasMore}
          currentPage={assessmentsPage}
          totalPages={assessmentsTotalPages}
          total={assessmentsTotal}
          onPageChange={handleAssessmentsPageChange}
          searchQuery={assessmentSearch}
          onSearchChange={setAssessmentSearch}
        />
      )}

      {/* Create Assessment Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          {/* Backdrop */}
          <div
            className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
            onClick={closeModal}
          />

          {/* Modal Content */}
          <div className="relative bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            {/* Modal Header */}
            <div className="flex items-center justify-between p-6 border-b border-gray-200">
              <h2 className="text-2xl font-bold text-gray-900">Create Assessment</h2>
              <button
                onClick={closeModal}
                className="p-2 rounded-md hover:bg-gray-100 transition-colors"
                aria-label="Close modal"
              >
                <X className="h-5 w-5 text-gray-600" />
              </button>
            </div>

            {/* Modal Body */}
            <form onSubmit={handleSubmit} className="p-6 space-y-6">
              {/* Role Selector */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Select a Role <span className="text-red-500">*</span>
                </label>
                <CreatableSelect
                  value={selectedRole}
                  onChange={(option) => {
                    setSelectedRole(option);
                    if (errors.role) {
                      setErrors({ ...errors, role: '' });
                    }
                  }}
                  options={jobRoles}
                  isSearchable
                  placeholder="Search and select a role..."
                  className="react-select-container"
                  classNamePrefix="react-select"
                  formatCreateLabel={(inputValue) => `Create "${inputValue}"`}
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      borderColor: errors.role ? '#ef4444' : state.isFocused ? '#3b82f6' : '#d1d5db',
                      boxShadow: state.isFocused && !errors.role ? '0 0 0 1px #3b82f6' : 'none',
                      '&:hover': {
                        borderColor: errors.role ? '#ef4444' : '#3b82f6',
                      },
                    }),
                  }}
                />
                {errors.role && (
                  <p className="mt-1 text-sm text-red-600">{errors.role}</p>
                )}
              </div>

              {/* Expected Work Experience - Dual Range Slider */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Expected Work Experience (Years) <span className="text-red-500">*</span>
                  <span className="ml-2 text-blue-600 font-normal">({workExpMin} - {workExpMax} years)</span>
                </label>
                <div className="space-y-4">
                  {/* Ant Design Range Slider */}
                  <div className="px-2">
                    <Slider
                      range
                      min={0}
                      max={15}
                      value={[workExpMin, workExpMax]}
                      onChange={(values) => {
                        if (Array.isArray(values) && values.length === 2) {
                          setWorkExpMin(values[0]);
                          setWorkExpMax(values[1]);
                          if (errors.workExp) {
                            setErrors({ ...errors, workExp: '' });
                          }
                        }
                      }}
                      marks={{
                        0: '0',
                        15: '15'
                      }}
                      tooltip={{
                        formatter: (value) => `${value} years`
                      }}
                    />
                  </div>
                </div>
                {errors.workExp && (
                  <p className="mt-1 text-sm text-red-600">{errors.workExp}</p>
                )}
              </div>

              {/* Interview Duration */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Interview Duration (Minutes) <span className="text-red-500">*</span>
                  <span className="ml-2 text-blue-600 font-normal">({interviewDuration} min)</span>
                </label>
                <div className="px-2">
                  <Slider
                    min={5}
                    max={40}
                    step={5}
                    value={interviewDuration}
                    onChange={(value) => {
                      setInterviewDuration(value);
                      if (errors.duration) {
                        setErrors({ ...errors, duration: '' });
                      }
                    }}
                    marks={{
                      5: '5',
                      40: '40'
                    }}
                    tooltip={{
                      formatter: (value) => `${value} min`
                    }}
                  />
                </div>
                {errors.duration && (
                  <p className="mt-1 text-sm text-red-600">{errors.duration}</p>
                )}
              </div>

              {/* Job Description */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Job Description (JD) <span className="text-red-500">*</span>
                </label>
                <textarea
                  value={jobDescription}
                  onChange={(e) => {
                    setJobDescription(e.target.value);
                    if (errors.jd) {
                      setErrors({ ...errors, jd: '' });
                    }
                  }}
                  rows={6}
                  placeholder="Enter the job description..."
                  className={`w-full px-3 py-2 border rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                    errors.jd ? 'border-red-500' : 'border-gray-300'
                  }`}
                />
                {errors.jd && (
                  <p className="mt-1 text-sm text-red-600">{errors.jd}</p>
                )}
              </div>

              {/* Modal Footer */}
              <div className="flex items-center justify-end space-x-3 pt-4 border-t border-gray-200">
                <button
                  type="button"
                  onClick={closeModal}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors"
                >
                  Create Assessment
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit Skill Modal */}
      {isEditSkillModalOpen && editingSkill && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          {/* Backdrop */}
          <div
            className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
            onClick={closeEditSkillModal}
          />

          {/* Modal Content */}
          <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
            {/* Modal Header */}
            <div className="flex items-center justify-between p-6 border-b border-gray-200">
              <h2 className="text-2xl font-bold text-gray-900">Edit Skill</h2>
              <button
                onClick={closeEditSkillModal}
                className="p-2 rounded-md hover:bg-gray-100 transition-colors"
                aria-label="Close modal"
              >
                <X className="h-5 w-5 text-gray-600" />
              </button>
            </div>

            {/* Modal Body */}
            <form onSubmit={handleSaveSkill} className="p-6 space-y-6">
              {/* Skill Name */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Skill Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={editSkillForm.name}
                  onChange={(e) => setEditSkillForm({ ...editSkillForm, name: e.target.value })}
                  placeholder="Enter skill name..."
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white"
                  required
                  minLength={2}
                  maxLength={10}
                />
                <p className="mt-1 text-xs text-gray-500">Skill name must be between 2 and 10 characters</p>
              </div>

              {/* Time Limit */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Time Limit (minutes) <span className="text-red-500">*</span>
                </label>
                <input
                  type="number"
                  min="1"
                  max="120"
                  value={editSkillForm.timeLimit || ''}
                  onChange={(e) => {
                    const value = e.target.value;
                    setEditSkillForm({ ...editSkillForm, timeLimit: value === '' ? 0 : parseInt(value) || 0 });
                  }}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white"
                  required
                />
              </div>

              {/* Difficulty */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-3">
                  Difficulty <span className="text-red-500">*</span>
                </label>
                <div className="inline-flex rounded-lg border border-gray-300 bg-white p-1" role="group">
                  <button
                    type="button"
                    onClick={() => setEditSkillForm({ ...editSkillForm, difficulty: 'Beginner' })}
                    className={`px-4 py-2 text-sm font-medium rounded-md transition-all ${
                      editSkillForm.difficulty === 'Beginner'
                        ? 'bg-green-100 text-green-800 shadow-sm'
                        : 'text-gray-700 hover:bg-gray-50'
                    }`}
                  >
                    Beginner
                  </button>
                  <button
                    type="button"
                    onClick={() => setEditSkillForm({ ...editSkillForm, difficulty: 'Intermediate' })}
                    className={`px-4 py-2 text-sm font-medium rounded-md transition-all ${
                      editSkillForm.difficulty === 'Intermediate'
                        ? 'bg-yellow-100 text-yellow-800 shadow-sm'
                        : 'text-gray-700 hover:bg-gray-50'
                    }`}
                  >
                    Intermediate
                  </button>
                  <button
                    type="button"
                    onClick={() => setEditSkillForm({ ...editSkillForm, difficulty: 'Advanced' })}
                    className={`px-4 py-2 text-sm font-medium rounded-md transition-all ${
                      editSkillForm.difficulty === 'Advanced'
                        ? 'bg-red-100 text-red-800 shadow-sm'
                        : 'text-gray-700 hover:bg-gray-50'
                    }`}
                  >
                    Advanced
                  </button>
                </div>
              </div>

              {/* Add Questions Checkbox */}
              <div className="flex items-center space-x-3 p-4 bg-gray-50 rounded-lg border border-gray-200">
                <input
                  type="checkbox"
                  id="hasQuestions"
                  checked={editSkillForm.hasQuestions}
                  onChange={(e) => setEditSkillForm({ ...editSkillForm, hasQuestions: e.target.checked })}
                  className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 cursor-pointer"
                />
                <label htmlFor="hasQuestions" className="text-sm font-medium text-gray-700 cursor-pointer flex-1">
                  Add questions for this skill
                </label>
                <HelpCircle className="h-4 w-4 text-gray-400" />
              </div>

              {/* Questions Section - Show when checkbox is checked */}
              {editSkillForm.hasQuestions && (
                <div className="space-y-4">
                  <div className="flex items-center justify-between">
                    <h3 className="text-sm font-semibold text-gray-900">Questions</h3>
                    <span className="text-xs text-gray-500">{editSkillForm.questions.length} question(s)</span>
                  </div>

                  {/* Questions List */}
                  <div className="space-y-2 max-h-60 overflow-y-auto">
                    {editSkillForm.questions.map((question, index) => (
                      <div key={question.id} className="flex items-start space-x-2 p-3 bg-white border border-gray-200 rounded-lg">
                        <span className="text-sm text-gray-500 mt-1 font-medium">{index + 1}.</span>
                        <input
                          type="text"
                          value={question.text}
                          onChange={(e) => handleUpdateQuestion(question.id, e.target.value)}
                          className="flex-1 px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                          placeholder="Enter question..."
                        />
                        <button
                          type="button"
                          onClick={() => handleDeleteQuestion(question.id)}
                          className="p-1.5 hover:bg-red-50 rounded transition-colors"
                          aria-label="Delete question"
                        >
                          <X className="h-4 w-4 text-red-600" />
                        </button>
                      </div>
                    ))}
                    {editSkillForm.questions.length === 0 && (
                      <p className="text-sm text-gray-500 text-center py-4">No questions added yet. Add your first question below.</p>
                    )}
                  </div>

                  {/* Add New Question */}
                  <div className="flex items-center space-x-2">
                    <input
                      type="text"
                      value={newQuestionText}
                      onChange={(e) => setNewQuestionText(e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          handleAddQuestion();
                        }
                      }}
                      placeholder="Enter a new question..."
                      className="flex-1 px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                    <button
                      type="button"
                      onClick={handleAddQuestion}
                      disabled={!newQuestionText.trim()}
                      className="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed flex items-center space-x-1"
                    >
                      <Plus className="h-4 w-4" />
                      <span>Add</span>
                    </button>
                  </div>
                </div>
              )}

              {/* Modal Footer */}
              <div className="flex items-center justify-end space-x-3 pt-4 border-t border-gray-200">
                <button
                  type="button"
                  onClick={closeEditSkillModal}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors"
                >
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Add Skill Modal */}
      {isAddSkillModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          {/* Backdrop */}
          <div
            className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
            onClick={closeAddSkillModal}
          />

          {/* Modal Content */}
          <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
            {/* Modal Header */}
            <div className="flex items-center justify-between p-6 border-b border-gray-200">
              <h2 className="text-2xl font-bold text-gray-900">Add Skill</h2>
              <button
                onClick={closeAddSkillModal}
                className="p-2 rounded-md hover:bg-gray-100 transition-colors"
                aria-label="Close modal"
              >
                <X className="h-5 w-5 text-gray-600" />
              </button>
            </div>

            {/* Modal Body */}
            <form onSubmit={handleAddNewSkill} className="p-6 space-y-6">
              {/* Skill Name */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Skill Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={addSkillForm.name}
                  onChange={(e) => setAddSkillForm({ ...addSkillForm, name: e.target.value })}
                  placeholder="Enter skill name..."
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white"
                  required
                  minLength={2}
                  maxLength={10}
                />
                <p className="mt-1 text-xs text-gray-500">Skill name must be between 2 and 10 characters</p>
              </div>

              {/* Time Limit */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Time Limit (minutes) <span className="text-red-500">*</span>
                </label>
                <input
                  type="number"
                  min="1"
                  max="120"
                  value={addSkillForm.timeLimit || ''}
                  onChange={(e) => {
                    const value = e.target.value;
                    setAddSkillForm({ ...addSkillForm, timeLimit: value === '' ? 0 : parseInt(value) || 0 });
                  }}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white"
                  required
                />
              </div>

              {/* Difficulty */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-3">
                  Difficulty <span className="text-red-500">*</span>
                </label>
                <div className="inline-flex rounded-lg border border-gray-300 bg-white p-1" role="group">
                  <button
                    type="button"
                    onClick={() => setAddSkillForm({ ...addSkillForm, difficulty: 'Beginner' })}
                    className={`px-4 py-2 text-sm font-medium rounded-md transition-all ${
                      addSkillForm.difficulty === 'Beginner'
                        ? 'bg-green-100 text-green-800 shadow-sm'
                        : 'text-gray-700 hover:bg-gray-50'
                    }`}
                  >
                    Beginner
                  </button>
                  <button
                    type="button"
                    onClick={() => setAddSkillForm({ ...addSkillForm, difficulty: 'Intermediate' })}
                    className={`px-4 py-2 text-sm font-medium rounded-md transition-all ${
                      addSkillForm.difficulty === 'Intermediate'
                        ? 'bg-yellow-100 text-yellow-800 shadow-sm'
                        : 'text-gray-700 hover:bg-gray-50'
                    }`}
                  >
                    Intermediate
                  </button>
                  <button
                    type="button"
                    onClick={() => setAddSkillForm({ ...addSkillForm, difficulty: 'Advanced' })}
                    className={`px-4 py-2 text-sm font-medium rounded-md transition-all ${
                      addSkillForm.difficulty === 'Advanced'
                        ? 'bg-red-100 text-red-800 shadow-sm'
                        : 'text-gray-700 hover:bg-gray-50'
                    }`}
                  >
                    Advanced
                  </button>
                </div>
              </div>

              {/* Add Questions Checkbox */}
              <div className="flex items-center space-x-3 p-4 bg-gray-50 rounded-lg border border-gray-200">
                <input
                  type="checkbox"
                  id="addHasQuestions"
                  checked={addSkillForm.hasQuestions}
                  onChange={(e) => setAddSkillForm({ ...addSkillForm, hasQuestions: e.target.checked })}
                  className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 cursor-pointer"
                />
                <label htmlFor="addHasQuestions" className="text-sm font-medium text-gray-700 cursor-pointer flex-1">
                  Add questions for this skill
                </label>
                <HelpCircle className="h-4 w-4 text-gray-400" />
              </div>

              {/* Questions Section - Show when checkbox is checked */}
              {addSkillForm.hasQuestions && (
                <div className="space-y-4">
                  <div className="flex items-center justify-between">
                    <h3 className="text-sm font-semibold text-gray-900">Questions</h3>
                    <span className="text-xs text-gray-500">{addSkillForm.questions.length} question(s)</span>
                  </div>

                  {/* Questions List */}
                  <div className="space-y-2 max-h-60 overflow-y-auto">
                    {addSkillForm.questions.map((question, index) => (
                      <div key={question.id} className="flex items-start space-x-2 p-3 bg-white border border-gray-200 rounded-lg">
                        <span className="text-sm text-gray-500 mt-1 font-medium">{index + 1}.</span>
                        <input
                          type="text"
                          value={question.text}
                          onChange={(e) => handleUpdateNewQuestion(question.id, e.target.value)}
                          className="flex-1 px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                          placeholder="Enter question..."
                        />
                        <button
                          type="button"
                          onClick={() => handleDeleteNewQuestion(question.id)}
                          className="p-1.5 hover:bg-red-50 rounded transition-colors"
                          aria-label="Delete question"
                        >
                          <X className="h-4 w-4 text-red-600" />
                        </button>
                      </div>
                    ))}
                    {addSkillForm.questions.length === 0 && (
                      <p className="text-sm text-gray-500 text-center py-4">No questions added yet. Add your first question below.</p>
                    )}
                  </div>

                  {/* Add New Question */}
                  <div className="flex items-center space-x-2">
                    <input
                      type="text"
                      value={newAddQuestionText}
                      onChange={(e) => setNewAddQuestionText(e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          handleAddNewQuestion();
                        }
                      }}
                      placeholder="Enter a new question..."
                      className="flex-1 px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                    <button
                      type="button"
                      onClick={handleAddNewQuestion}
                      disabled={!newAddQuestionText.trim()}
                      className="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed flex items-center space-x-1"
                    >
                      <Plus className="h-4 w-4" />
                      <span>Add</span>
                    </button>
                  </div>
                </div>
              )}

              {/* Modal Footer */}
              <div className="flex items-center justify-end space-x-3 pt-4 border-t border-gray-200">
                <button
                  type="button"
                  onClick={closeAddSkillModal}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors"
                >
                  Add Skill
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Delete Skill Confirmation Modal */}
      {isDeleteSkillModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          {/* Backdrop */}
          <div
            className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
            onClick={closeDeleteSkillModal}
          />

          {/* Modal Content */}
          <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full">
            {/* Modal Header */}
            <div className="flex items-center justify-between p-6 border-b border-gray-200">
              <h2 className="text-xl font-bold text-gray-900">Delete Skill</h2>
              <button
                onClick={closeDeleteSkillModal}
                className="p-2 rounded-md hover:bg-gray-100 transition-colors"
                aria-label="Close modal"
              >
                <X className="h-5 w-5 text-gray-600" />
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-6">
              <p className="text-gray-700 mb-6">
                Are you sure you want to delete the skill <span className="font-semibold">"{skillToDelete?.name}"</span>? This action cannot be undone.
              </p>
            </div>

            {/* Modal Footer */}
            <div className="flex items-center justify-end space-x-3 p-6 border-t border-gray-200">
              <button
                type="button"
                onClick={closeDeleteSkillModal}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleDeleteSkill}
                className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition-colors"
              >
                Delete Skill
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Dashboard;

